module.exports = __webpack_public_path__ + "static/media/favicon.078cfb5f.ico";